<template>
  <section class="section" v-if="tradeIn">
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <h1 class="title is-4">Detalle de Trade-In #{{ tradeIn.id }}</h1>
        </div>
      </div>
      <div class="level-right">
        <!-- Botones de acción basados en el estado -->
        <div class="level-item" v-if="!tradeIn.date_receipt">
          <button class="button is-info" @click="handleMarkAsReceived" :class="{'is-loading': updating}">Marcar como Recibido</button>
        </div>
        <div class="level-item" v-else-if="!tradeIn.diagnostic_date">
          <button class="button is-warning" @click="handleApproveDiagnostic" :class="{'is-loading': updating}">Aprobar Diagnóstico</button>
        </div>
        <!-- Botón regresar -->
        <div class="level-item ml-4">
          <a @click="$router.go(-1)" class="button is-light is-small">
            <span class="material-icons" style="font-size: 16px; margin-right: 4px;">arrow_back</span>
            Regresar
          </a>
        </div>
      </div>
    </nav>

    <div class="columns is-multiline">
      <div class="column is-8">
        <div class="columns">
          <div class="column is-6">
            <div class="box">
              <p class="title is-6">📦 Equipo Entregado (Trade-In)</p>
              <div class="is-flex is-align-items-center mb-4" v-if="tradeIn.tradeInImages && tradeIn.tradeInImages.length">
                <figure class="image is-128x128 mr-4">
                  <img :src="mainTradeInImage" style="object-fit: contain; border-radius: 8px;" />
                </figure>
              </div>
              <p><strong>Modelo:</strong> {{ tradeIn.tradeInProductName }}</p>
              <router-link :to="'/productos/detalle/' + tradeIn.tradeInProductId" class="is-size-7">Ver producto #{{ tradeIn.tradeInProductId }}</router-link>
              <hr />
              <div v-if="tradeIn.market_price">
                <p><strong>Propuesta sugerida:</strong> {{ formatMoney(tradeIn.suggested_proposal) }}</p>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="box">
              <p class="title is-6">✨ Nuevo Equipo Solicitado</p>
              <p><strong>Modelo:</strong> {{ tradeIn.targetProductName }}</p>
              <p><strong>Precio GivU:</strong> {{ formatMoney(tradeIn.targetProductPrice) }}</p>
              <router-link :to="'/inventario/detalle/' + tradeIn.targetProductId" class="is-size-7">Ver inventario #{{ tradeIn.targetProductId }}</router-link>
              <hr v-if="tradeIn.proposal_amount"/>
              <div v-if="tradeIn.proposal_amount">
                <p class="has-text-success"><strong>Monto acordado:</strong> {{ formatMoney(tradeIn.proposal_amount) }}</p>
                <p class="is-size-7">Diferencia a favor/contra: {{ formatMoney(tradeIn.targetProductPrice - tradeIn.proposal_amount) }}</p>
              </div>
              <!-- <div v-else class="field has-addons mt-4">
                <div class="control">
                  <input class="input" type="number" v-model="newProposalAmount" placeholder="Monto propuesta">
                </div>
                <div class="control">
                  <button class="button is-primary" @click="handleUpdateProposal" :class="{'is-loading': updating}">Fijar Monto</button>
                </div>
              </div> -->
            </div>
          </div>
        </div>

        <div class="box">
          <p class="title is-6">Línea de Tiempo de Operación</p>
          <div class="timeline">
            <div class="timeline-item" :class="{'is-success': tradeIn.created_at}">
              <div class="timeline-marker"></div>
              <div class="timeline-content">
                <p class="heading">{{ formatDate(tradeIn.created_at) }}</p>
                <p>Operación iniciada</p>
              </div>
            </div>
            <div class="timeline-item" :class="{'is-success': tradeIn.date_receipt}">
              <div class="timeline-marker"></div>
              <div class="timeline-content">
                <p class="heading">{{ formatDate(tradeIn.date_receipt) || 'Pendiente' }}</p>
                <p>Equipo viejo recibido en GivU</p>
              </div>
            </div>
            <div class="timeline-item" :class="{'is-success': tradeIn.diagnostic_date}">
              <div class="timeline-marker"></div>
              <div class="timeline-content">
                <p class="heading">{{ formatDate(tradeIn.diagnostic_date) || 'Pendiente' }}</p>
                <p>Diagnóstico aprobado</p>
              </div>
            </div>
            <div class="timeline-item" :class="{'is-success': tradeIn.sellId}">
              <div class="timeline-marker"></div>
              <div class="timeline-content">
                <p class="heading">{{ tradeIn.sellId ? 'Completado' : 'Pendiente' }}</p>
                <p>Pago de diferencia / Venta vinculada</p>
              </div>
            </div>
            <div class="timeline-item" :class="{'is-success': tradeIn.closed_date}">
              <div class="timeline-marker"></div>
              <div class="timeline-content">
                <p class="heading">{{ formatDate(tradeIn.closed_date) || 'Pendiente' }}</p>
                <p>Nuevo equipo enviado (Operación Cerrada)</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-4">
        <div class="box">
          <p class="title is-6">Información del Usuario</p>
          <p><strong>Nombre:</strong> {{ tradeIn.userName }}</p>
          <p><strong>Email:</strong> {{ tradeIn.email }}</p>
          <p><strong>Teléfono:</strong> {{ tradeIn.phone }}</p>
          <router-link :to="'/usuarios/detalle/' + tradeIn.userId" class="button is-small is-link is-fullwidth mt-4">Ver perfil de usuario</router-link>

          <div v-if="tradeIn.address" class="notification is-light mt-4">
            <p class="has-text-weight-bold is-size-7 mb-1">Dirección de Envío:</p>
            <p class="is-size-7">{{ tradeIn.address.street }} {{ tradeIn.address.street_number }}</p>
            <p class="is-size-7">{{ tradeIn.address.neighborhood }}, {{ tradeIn.address.city }}</p>
            <p class="is-size-7">C.P. {{ tradeIn.address.zip_code }}</p>
          </div>
        </div>

        <div class="box" v-if="tradeIn.contact_info">
          <p class="title is-6">Contacto Adicional</p>
          <div v-if="formattedContact">
            <p><strong>Nombre:</strong> {{ formattedContact.name }}</p>
            <p><strong>Email:</strong> {{ formattedContact.email }}</p>
            <p v-if="formattedContact.phone"><strong>Teléfono:</strong> {{ formattedContact.phone }}</p>
          </div>
          <p v-else>{{ tradeIn.contact_info }}</p>
        </div>

        <div class="box" v-if="tradeIn.diagnostic_date && !tradeIn.closed_date">
          <p class="title is-6">Cerrar Operación</p>
          <p class="is-size-7 mb-4">Cierre la operación una vez que el nuevo equipo haya sido enviado al cliente.</p>
          <button class="button is-success is-fullwidth" @click="handleCloseTradeIn" :class="{'is-loading': updating}">Cerrar y Marcar Enviado</button>
        </div>
      </div>
    </div>
  </section>
  <div v-else-if="loading" class="section has-text-centered">
    <p>Cargando detalles de la operación...</p>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'TradeInDetail',
  data () {
    return {
      tradeIn: null,
      loading: false,
      updating: false,
      newProposalAmount: 0
    }
  },
  computed: {
    upgradeId () {
      return this.$route.params.upgradeId
    },
    mainTradeInImage () {
      if (!this.tradeIn.tradeInImages || !this.tradeIn.tradeInImages.length) return ''
      const main = this.tradeIn.tradeInImages.find(i => i.main)
      return main ? main.url : this.tradeIn.tradeInImages[0].url
    },
    formattedContact () {
      if (!this.tradeIn || !this.tradeIn.contact_info) return null
      if (typeof this.tradeIn.contact_info === 'object') return this.tradeIn.contact_info
      try {
        return JSON.parse(this.tradeIn.contact_info)
      } catch (e) {
        return null
      }
    }
  },
  methods: {
    ...mapActions(['getTradeInDetail', 'approveDiagnostic', 'markTradeInAsReceived', 'updateTradeInProposal', 'closeTradeIn']),
    async fetchDetail () {
      this.loading = true
      try {
        const res = await this.getTradeInDetail(this.upgradeId)
        if (res && res.success) {
          this.tradeIn = res.payload
          this.newProposalAmount = this.tradeIn.proposal_amount || 0
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async handleMarkAsReceived () {
      this.updating = true
      try {
        await this.markTradeInAsReceived(this.upgradeId)
        await this.fetchDetail()
      } catch (e) {
        alert('Error: ' + e.message)
      } finally {
        this.updating = false
      }
    },
    async handleApproveDiagnostic () {
      this.updating = true
      try {
        await this.approveDiagnostic(this.upgradeId)
        await this.fetchDetail()
      } catch (e) {
        alert('Error: ' + e.message)
      } finally {
        this.updating = false
      }
    },
    async handleUpdateProposal () {
      this.updating = true
      try {
        await this.updateTradeInProposal({ upgradeId: this.upgradeId, amount: this.newProposalAmount })
        await this.fetchDetail()
      } catch (e) {
        alert('Error: ' + e.message)
      } finally {
        this.updating = false
      }
    },
    async handleCloseTradeIn () {
      this.updating = true
      try {
        await this.closeTradeIn(this.upgradeId)
        await this.fetchDetail()
      } catch (e) {
        alert('Error: ' + e.message)
      } finally {
        this.updating = false
      }
    },
    formatMoney (val) {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(val)
    },
    formatDate (date) {
      if (!date) return ''
      return moment(date).format('DD/MM/YYYY HH:mm')
    }
  },
  mounted () {
    this.fetchDetail()
  }
}
</script>

<style scoped>
.timeline {
  display: flex;
  flex-direction: column;
  padding: 1rem 0.5rem;
  margin-left: 1rem;
}
.timeline-item {
  position: relative;
  padding-left: 2.5rem;
  padding-bottom: 2rem;
  border-left: 2px solid #dbdbdb;
}
@media screen and (max-width: 768px) {
  .timeline {
    margin-left: 0.5rem;
  }
}
.timeline-item.is-success {
  border-left: 2px solid #48c78e;
}
.timeline-marker {
  position: absolute;
  left: -9px;
  top: 0;
  width: 16px;
  height: 16px;
  background-color: #dbdbdb;
  border-radius: 50%;
}
.timeline-item.is-success .timeline-marker {
  background-color: #48c78e;
}
.timeline-content {
  margin-top: -4px;
}
</style>
